import { UsageAltNav } from '@clearkit/icons';
import Helmet from 'react-helmet';

import { PageLayout } from '~/components/PageLayout';
import BillingUsageMetersList from '~/components/usage/BillingUsageMeters/List';
import { AccountFlagEnum } from '~/generated/graphql';
import { useFeatureFlag } from '~/hooks/account';

import { CreditsBasedUsageLayout } from '../../../components/usage/CreditBasedUsageLayout';

const Usage = () => {
  const creditsBasedUsage = useFeatureFlag(
    AccountFlagEnum.AllowCreditsBasedUsage,
  ).enabled;

  return (
    <>
      <Helmet>
        <title>Usage</title>
      </Helmet>
      <PageLayout>
        <PageLayout.Header>
          <PageLayout.Tile>
            <UsageAltNav />
          </PageLayout.Tile>
          <PageLayout.Heading>Usage</PageLayout.Heading>
          <PageLayout.SubHeading>
            Understand your platform usage
          </PageLayout.SubHeading>
        </PageLayout.Header>
        <PageLayout.Body>
          <PageLayout.Content className="mb-12 space-y-6">
            <h2 className="text-base text-gray-600">
              <UsageDescription creditsBasedUsage={creditsBasedUsage} />
            </h2>
            {creditsBasedUsage ? (
              <CreditsBasedUsageLayout />
            ) : (
              <BillingUsageMetersList />
            )}
          </PageLayout.Content>
        </PageLayout.Body>
      </PageLayout>
    </>
  );
};

type UsageDescriptionProps = {
  creditsBasedUsage: boolean;
};

function UsageDescription({ creditsBasedUsage }: UsageDescriptionProps) {
  if (creditsBasedUsage) {
    return (
      <>
        From records enriched in your CRM or MAP to the actions you power with
        data like Alerts we only count credits for what you use. Credits reset
        each month.&nbsp;
        <a href="https://help.clearbit.com/hc/en-us/articles/16764226936471-Understanding-Credits-and-Usage">
          Learn more about credits and usage.
        </a>
      </>
    );
  }
  return (
    <>
      View your active platform plans, usage, and historical usage trends. For
      information on API usage and legacy applications,{' '}
      <a href="https://dashboard.clearbit.com/dashboard">
        visit the API dashboard.
      </a>
    </>
  );
}

export default Usage;
